import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { LayoutBody, LayoutBodyWrapper, LayoutContainer } from './styles';
import { Header, Sidebar } from '../Header2';

interface LayoutProps {
  children?: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [showMenu, setShowMenu] = React.useState(false);
  const [appIsReady, setAppIsReady] = React.useState(false);

  // Exemplo: simular carregamento inicial
  React.useEffect(() => {
    const token = localStorage.getItem("AccessToken");
    setTimeout(() => setAppIsReady(true), token ? 0 : 2000); // 2 segundos de "load"
  }, []);
  // Função para renderizar o spinner de loading
  const renderLoading = () => (
    <Box flex={1} display="flex" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  );

  if (!appIsReady) {
    return renderLoading();
  }

  return (
    <LayoutContainer>
      <Sidebar showMenu={showMenu} onClose={() => setShowMenu(false)} />
      
      <LayoutBody>
        <Header onClickOptions={() => setShowMenu((prev) => !prev)} />

        <LayoutBodyWrapper>
          {children}
        </LayoutBodyWrapper>
      </LayoutBody>
    </LayoutContainer>
  );
}
